// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* --------------------------------- ESTILOS BARRA DE DIVISION --------------------------------- */\r\n\r\n.dvsn-style{\r\n    width:100%; \r\n    height:10px;\r\n    position: relative;\r\n    /*top: 10px;*/  \r\n}\r\n\r\n.dvsn-style img { \r\n    width:100%; \r\n    height:100%; \r\n} ", ""]);
// Exports
module.exports = exports;
